import { createConcurrencyLimiter } from '@/lib/utils'

// Shared concurrency limiters for all preview-related requests in Drive
// Tune these numbers based on network capacity and backend limits
export const limitHeic = createConcurrencyLimiter(5)
export const limitThumb = createConcurrencyLimiter(6)
